import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchDistricts } from "services/services.congressman";
import { getFormattedOptions } from "utility/helpers";

const useDistricts = () => {
  const [districts, setDistricts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const refetch = useCallback(() => {
    setIsLoading(true);

    fetchDistricts({
      callback: (data) => {
        setDistricts(data);
        setIsLoading(false);
      },
    });
  }, []);

  const options = useMemo(() => {
    return getFormattedOptions("name", districts);
  }, [districts]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return {
    data: districts,
    isLoading,
    refetch,
    options,
  };
};

export default useDistricts;
